module.exports = __webpack_public_path__ + "static/media/undraw_blank_canvas_3rbb.d32ae8cf.svg";